import { render, staticRenderFns } from "./BostonUserRegister.vue?vue&type=template&id=dbfe3c7a&scoped=true"
import script from "./BostonUserRegister.vue?vue&type=script&lang=js"
export * from "./BostonUserRegister.vue?vue&type=script&lang=js"
import style0 from "./BostonUserRegister.vue?vue&type=style&index=0&id=dbfe3c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfe3c7a",
  null
  
)

export default component.exports